import { useSelector } from "react-redux";
import axiosInstance from "../../components/AxiosInstance";
import { useCheckbox } from "../../components/InactiveCheckbox";
import {
  ALL_SCREENS,
  API_BASE_URL,
  APPROVED,
  CREATE,
  DATA_COLLECTION_PAGE,
  DATA_COLLECTION_TYPE,
  DELETE,
  EXECUTIVE_OFFICER,
  GOAL,
  GOAL_HIERACRHY,
  LEAD_RBT,
  PROGRAM_BOOK,
  PROGRAM_BOOK_TEMPLATE,
  RB_BT,
  SESSION_NOTE_97151,
  SESSION_NOTE_97153,
  SESSION_NOTE_97155,
  SESSION_NOTE_97156,
  SESSION_NOTE_H0032,
  SESSION_NOTE_PAGE,
  SYSTEM_ADMIN,
  UPDATE,
} from "../../constants";

export const usePermissions = () => {
  // 🔹 Role & User Data
  const role = localStorage.getItem("role");
  const userId = parseInt(localStorage.getItem("userId"));
  const { showInactive } = useCheckbox();
  const userPermissions = useSelector((state) => state.permissions.permissions);
  const clients = useSelector((state) => state.clients);
  const staff = useSelector((state) => state.staffs);

  // ------------------------------------------------
  // ✅ PERMISSION CHECKING FUNCTIONS
  // ------------------------------------------------

  const checkPermission = (screen, action, owner = null, status = null) => {
    console.log(screen, action, owner, " PERMISSION ", role, status);

    if (role === SYSTEM_ADMIN || role == EXECUTIVE_OFFICER) {
      console.log("hye");
      if (screen === GOAL_HIERACRHY) return false;
      return true;
    }
    if (screen == SESSION_NOTE_PAGE)
      return (
        checkPermission(SESSION_NOTE_97153, action, owner) ||
        checkPermission(SESSION_NOTE_97151, action, owner) ||
        checkPermission(SESSION_NOTE_97155, action, owner) ||
        checkPermission(SESSION_NOTE_97156, action, owner) ||
        checkPermission(SESSION_NOTE_H0032, action, owner)
      );
    if (action == DELETE && status == APPROVED) {
      return false;
    }
    if (screen == DATA_COLLECTION_PAGE) {
      return (
        checkPermission(PROGRAM_BOOK, action, owner) ||
        checkPermission(PROGRAM_BOOK_TEMPLATE, action, owner) ||
        checkPermission(GOAL, action, owner)
      );
    }
    if (owner && owner == "Other") {
      return (userPermissions || [] || []).some(
        (permission) =>
          permission.screen === screen &&
          permission?.action?.AssignedClients?.toLowerCase().includes(
            action.toLowerCase()
          )
      );
    }
    console.log(userPermissions || [], "permission self");
    return (
      (userPermissions || [] || []).some(
        (permission) =>
          permission.screen === screen &&
          permission?.action?.OwnClients?.toLowerCase().includes(
            action.toLowerCase()
          )
      ) ||
      (userPermissions || [] || []).some((permission) => {
        console.log(permission.screen, "screen here", screen);
        if (permission.screen === screen) {
          console.log(
            action.toLowerCase(),
            "action lower",
            permission.action.Own.toLowerCase()
          );
        }
        return (
          permission.screen === screen &&
          permission?.action?.Own?.toLowerCase().includes(action.toLowerCase())
        );
      })
    );
  };

  const checkAllClientPermission = (screen, action) => {
    return (userPermissions || []).some(
      (permission) =>
        permission.screen === screen &&
        permission?.action?.AllClients?.toLowerCase().includes(
          action.toLowerCase()
        )
    );
  };

  const checkStaffPermission = (screen, action) => {
    if (role === SYSTEM_ADMIN) return true;
    return (userPermissions || []).some(
      (permission) =>
        permission.screen === screen &&
        permission?.action?.AssignedStaff?.toLowerCase().includes(
          action.toLowerCase()
        )
    );
  };

  const CheckDataCollectionPermission = (field) => {
    if (field === DATA_COLLECTION_TYPE) {
      return !(role === LEAD_RBT || role === RB_BT);
    }
    return true;
  };

  // ------------------------------------------------
  // ✅ SORTING FUNCTION (FIRST BY firstName, THEN BY lastName)
  // ------------------------------------------------

  const sortByName = (list) => {
    return list.sort((a, b) => {
      const nameA = `${a?.firstName || ""} ${a?.lastName || ""}`.trim();
      const nameB = `${b?.firstName || ""} ${b?.lastName || ""}`.trim();
      return nameA.localeCompare(nameB);
    });
  };

  // ------------------------------------------------
  // ✅ CLIENT & STAFF RETRIEVAL FUNCTIONS (SORTED)
  // ------------------------------------------------

  const giveClients = (screen, action) => {
    let clientList = [];

    if (role === SYSTEM_ADMIN || role === EXECUTIVE_OFFICER) {
      clientList = clients?.allClients || [];
    } else {
      const screenPermissions = (userPermissions || []).find(
        (permission) =>
          permission.screen === screen || permission.screen === ALL_SCREENS
      );

      if (!screenPermissions) {
        clientList = clients?.assignedClients || [];
      } else if (screenPermissions.action.AllClients?.includes(action)) {
        clientList = clients?.allClients || [];
      } else if (screenPermissions.action.AssignedClients?.includes(action)) {
        clientList = clients?.assignedClients || [];
      } else if (screenPermissions.action.OwnClients?.includes(action)) {
        clientList = clients?.ownClients || [];
      }
    }

    // 🔹 Sort clients by firstName, then lastName before returning
    return sortByName(
      clientList.filter((client) => showInactive || client.status === "Active")
    );
  };

  const giveStaff = (screen, action) => {
    let staffList = [];

    if (role === SYSTEM_ADMIN) {
      if (
        [
          SESSION_NOTE_97151,
          SESSION_NOTE_97156,
          SESSION_NOTE_97155,
          SESSION_NOTE_H0032,
        ].includes(screen)
      ) {
        staffList = staff?.bcbaAndAbove || [];
      } else {
        staffList = staff?.allStaff || [];
      }
    } else {
      const screenPermissions = (userPermissions || []).find(
        (permission) =>
          permission.screen === screen || permission.screen === ALL_SCREENS
      );

      if (!screenPermissions) {
        staffList = staff?.assignedStaff || [];
      } else if (screenPermissions.action.AllStaff?.includes(action)) {
        staffList = staff?.allStaff || [];
      } else if (screenPermissions.action.AssignedStaff?.includes(action)) {
        staffList = staff?.assignedStaff || [];
      } else if (screenPermissions.action.Own?.includes(action)) {
        const ownStaff = staff?.allStaff?.find((staff) => staff.id === userId);
        staffList = ownStaff ? [ownStaff] : [];
      }
    }

    // 🔹 Sort staff by firstName, then lastName before returning
    return sortByName(
      staffList.filter((staff) => showInactive || staff.status === "Active")
    );
  };

  // ------------------------------------------------
  // ✅ APPROVER & SUPERVISOR FUNCTIONS (SORTED)
  // ------------------------------------------------

  const checkApprover = async (staffId) => {
    if (role === SYSTEM_ADMIN || role === EXECUTIVE_OFFICER) return true;

    try {
      const response = await axiosInstance.post(
        `${API_BASE_URL}/api/getsupervisorsforapproval`,
        { id: staffId },
        { withCredentials: true }
      );
      return response.data.some((approver) => approver.id === userId);
    } catch (error) {
      console.error("Error fetching approver list:", error);
      return false;
    }
  };

  const fetchSupervisor = async (staffId) => {
    try {
      const response = await axiosInstance.post(
        `${API_BASE_URL}/api/getsupervisorsforapproval`,
        { id: staffId },
        { withCredentials: true }
      );

      const sortedSupervisors = sortByName(response.data || []);
      return sortedSupervisors;
    } catch (error) {
      console.error("Error fetching supervisor list:", error);
      return [];
    }
  };

  const giveClientsForGuardian = async () => {
    try {
      const clientIds = localStorage.getItem("clientId")?.split(",") || [];

      // Fetch all clients
      const response = await axiosInstance.post(
        API_BASE_URL + "/api/viewallclient"
      );
      const clients = response.data;

      // Filter clients based on stored client IDs
      return sortByName(
        clients.filter((client) => clientIds.includes(client.id.toString()))
      );
    } catch (error) {
      console.error("Error fetching clients for guardian:", error);
      return [];
    }
  };

  const giveExecutiveDirector = async () => {
    // Filter staffs by role "Executive Director"
    const response = await axiosInstance.post(
      API_BASE_URL + "/api/viewstaffbyrole",
      { role: EXECUTIVE_OFFICER }
    );
    const executiveDirectors = response.data;
    console.log("all staff", executiveDirectors);
    // Sort the list of staffs by firstName, then lastName
    return sortByName(
      executiveDirectors?.filter(
        (staff) => showInactive || staff.status === "Active"
      )
    );
  };

  // ------------------------------------------------
  // ✅ RETURN FINAL OBJECT (ALL SORTED LISTS INCLUDED)
  // ------------------------------------------------

  return {
    checkPermission,
    checkAllClientPermission,
    checkStaffPermission,
    CheckDataCollectionPermission,
    giveClients, // ✅ Sorted Clients (by firstName, then lastName)
    giveStaff, // ✅ Sorted Staff (by firstName, then lastName)
    checkApprover,
    fetchSupervisor, // ✅ Sorted Supervisors (by firstName, then lastName)
    giveClientsForGuardian,
    giveExecutiveDirector,
  };
};
